import { Pipe, PipeTransform } from '@angular/core';

import { environment } from '@env/environment';

/**
 * Resolves a CMS media URL to an absolute one by prefixing the Strapi service origin
 * (`environment.cmsUrl`). Strapi returns root-relative paths (e.g. `/uploads/logo.png`) when the
 * local upload provider is used; URLs that are already absolute (CDN / S3) are returned untouched.
 *
 * Pure pipe — `environment.cmsUrl` is a build-time constant, so the result never changes for a
 * given input. Replaces the legacy `addStrapiDomainName` pipe that read the origin from
 * `FeatureManager`.
 */
/**
 * The pipe's logic as a plain function, so components can resolve media URLs outside a template —
 * `cms-image` needs it to assemble a `srcset` from several format URLs at once, which a pipe cannot
 * express. The pipe below is a thin wrapper, keeping one implementation of the rule.
 */
export function withStrapiOrigin(url: string | null | undefined): string {
    if (!url) {
        return '';
    }

    if (/^(https?:)?\/\//i.test(url) || url.startsWith('data:')) {
        return url;
    }

    return `${environment.cmsUrl}${url}`;
}

@Pipe({
    name: 'addStrapiDomainName',
})
export class AddStrapiDomainNamePipe implements PipeTransform {
    public transform(url: string | null | undefined): string {
        return withStrapiOrigin(url);
    }
}
